export enum MeetingStatus {
    Pending,
    InProgress,
    Expired,
}
